// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DocuSignSuccessPage.css */
.docusign-success-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  padding: 20px;
}

.breadcrumbs{
  padding: 1rem;
}
/* span{
 transform: rotate(180deg);
 position: relative;
 top: 4px;
 width: 13px;
 margin: 0 3px;

} */`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/docusign-success/DocusignSuccessPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;;;;;;;GAOG","sourcesContent":["/* DocuSignSuccessPage.css */\n.docusign-success-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  padding: 20px;\n}\n\n.breadcrumbs{\n  padding: 1rem;\n}\n/* span{\n transform: rotate(180deg);\n position: relative;\n top: 4px;\n width: 13px;\n margin: 0 3px;\n\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
